import React from 'react'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import { PersistGate } from 'redux-persist/integration/react'

import Routes from './routes'
import history from './services/history'
import { store, persistor } from 'store/StoreConfig'
import GlobalStyle from './styles/global'

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <Router history={history}>
          <Routes />
          <GlobalStyle />
          <ToastContainer autoClose={1500} />
        </Router>
      </PersistGate>
    </Provider>
  )
}

export default App
